import React from "react";
import { DatePicker, Form } from "antd";
import dayjs from "dayjs";
import { DATE_FORMAT } from "../constants/string";
import { dateToString } from "../frameworks/Util";

const CustomDatePicker = ({ name, label, rules, style, placeholder, disabled, format, labelCol, wrapperCol, buttonStyle, showTime, disabledDate, ...props }) => {
  return (
    <Form.Item 
      label={label} 
      style={style ? style : { marginRight : 10}}
      name={name}
      rules={rules}
      getValueProps={(value) => ({ value: value && dayjs(value, DATE_FORMAT) })}
      normalize={(value) => value ? dateToString(value) : null}
      labelCol={labelCol}
      wrapperCol={wrapperCol}
    >
    <DatePicker style={{ width : '100%', ...buttonStyle }} placeholder={placeholder} disabled={disabled} format={format} showTime={showTime} disabledDate={disabledDate}/>
  </Form.Item>
  );
};

export default CustomDatePicker;